<template lang="pug">
  - $image_path = '@/assets/images/terms/';
  .page-terms
    CloseButton
    transition(name="slidein" appear)
      .frame
        h2.frame-maintitle 利用規約
        .frame-textarea
          h3.frame-textarea-title 応募要項
          p.frame-textarea-text.text-break 以下をご一読の上、ご応募ください。

          h3.frame-textarea-subtitle ●キャンペーン応募期間
          p.frame-textarea-text.text-nest.text-break 2020年5月12日(火)～2020年5月31日(日)23:59

          h3.frame-textarea-subtitle ●賞品・当選人数
          .frame-textarea-inner.text-nest.text-break
            p.frame-textarea-text.text-break 抽選で合計2020名様に以下の賞品が当たります。
            p.frame-textarea-text.text-indent ・【超ハッピーターン賞】：GARMINスマートウォッチ (VENU Black / Slate)：3名様
            p.frame-textarea-text.text-indent ・【やっターン賞】：108gハッピーターン　1ケース(12袋入)：1500名様
            p.frame-textarea-text.text-indent ・【とっターン賞】：Amazonギフト券500円分：517名様

          h3.frame-textarea-subtitle ●応募方法
          .frame-textarea-inner.text-nest.text-break
            p.frame-textarea-text スマホゲーム「走れ！ターン王子」をプレイし、ハートの数に気をつけながらゴールを目指します。ゴールした際に獲得した点数によってアクセスできる各賞の応募画面から、「ツイートして応募」ボタンを押して、自動で入力されたツイート文を投稿し、ご応募ください。その際、ハッピーターン公式Twitterアカウント「#[a(href="https://twitter.com/happyturnkameda" target="_blank" rel="noopener") @happyturnkameda]」のフォローが必要となります。
            p.frame-textarea-text.text-break 2020年5月31日23:59までのTwitter投稿をもって、応募完了といたします。
            p.frame-textarea-text.text-indent ※ハッピーターン公式Twitterアカウント「#[a(href="https://twitter.com/happyturnkameda" target="_blank" rel="noopener") @happyturnkameda]」をフォローしなくてもゲームで遊べます。
            p.frame-textarea-text.text-indent ※本ゲームはスマートフォン専用ゲームとなります。パソコンでのゲームプレイは出来ません。
            p.frame-textarea-text.text-indent ※獲得点数を書き換えての応募（投稿）は、無効となります。
            p.frame-textarea-text.text-indent ※本キャンペーンへのご応募は、期間中お一人様何度でも可能です。
            p.frame-textarea-text.text-indent ※お客様がお使いいただく端末によっては、動作に不具合が生じる場合がございます。また、正常に投稿完了されなかった場合、抽選対象外とさせていただく場合がございます。動作保証端末ページをご確認ください。
            p.frame-textarea-text.text-indent.text-break ※下記の方法で投稿された場合、参加とみなされない場合がございます。
            p.frame-textarea-text.text-indent ・他人の投稿のテキストを改変し、投稿した場合
            p.frame-textarea-text.text-indent ・Twitter社以外の第三者が作成したアプリやツールを介してリツイートを実施した場合
            p.frame-textarea-text.text-indent ・ご応募の際、ご自身のTwitterアカウントを非公開設定にしている場合またはご応募後にハッピーターン公式Twitterアカウント「#[a(href="https://twitter.com/happyturnkameda" target="_blank" rel="noopener") @happyturnkameda]」のフォローを解除した場合

          h3.frame-textarea-subtitle ●当選発表
          .frame-textarea-inner.text-nest.text-break
            p.frame-textarea-text.text-indent ・キャンペーン期間終了後、厳正なる抽選の上で当選者を決定いたします。
            p.frame-textarea-text.text-indent ・当選は1アカウント1回とさせていただきます。
            p.frame-textarea-text.text-indent ・通信障害等によりダイレクトメッセージを受信できなかった場合でも亀田製菓は責任を負いかねますので、あらかじめご了承下さい。
            p.frame-textarea-text.text-indent ・Amazonギフト券は、ギフト券番号をTwitterのダイレクトメッセージにて送付いたします。
            .text-nest
              p.frame-textarea-text.text-indent ※ハッピーターン公式Twitterアカウントよりご連絡いたしますので、メッセージを受信できるよう設定してください。
              p.frame-textarea-text.text-indent ※ご応募の際、非公開設定をONにされている方は、抽選対象外になりますのでご注意ください。
              p.frame-textarea-text.text-indent ※ご応募後にハッピーターン公式Twitterアカウントのフォローを解除した場合は、抽選対象外になりますのでご注意ください。
              p.frame-textarea-text.text-indent ※ダイレクトメッセージの再送・Amazonギフト券番号の再発行はいたしません。
            p.frame-textarea-text.text-indent ・当選者への通知は、2020年6月上旬頃を予定しています。

          h3.frame-textarea-subtitle ●応募資格
          .frame-textarea-inner.text-nest.text-break
            p.frame-textarea-text.text-indent ・本応募要項、利用規約に同意していただいた方
            p.frame-textarea-text.text-indent.text-break ・未成年者の方は保護者の同意を得た上でご応募ください。未成年者からの応募があった場合、保護者の同意を得たものとみなします。
            p.frame-textarea-text.text-break 同意なく応募され何らかの被害や問題が生じた場合、亀田製菓株式会社（以下「当社」といいます）及び「走れ！ターン王子」事務局（以下「事務局」といいます）では一切責任を負いません。
            p.frame-textarea-text.text-indent ・Twitterのアカウントをお持ちの方
            .text-nest
              p.frame-textarea-text.text-indent ※Twitterアカウントをお持ちでない方は下記サイトより新規登録をしてください。
              p.frame-textarea-text.text-nest
                a(href="https://twitter.com" target="_blank" rel="noopener") https://twitter.com
            p.frame-textarea-text.text-indent ・ハッピーターン公式Twitterアカウント「#[a(href="https://twitter.com/happyturnkameda" target="_blank" rel="noopener") @happyturnkameda]」をフォローしている方
            p.frame-textarea-text.text-indent ・スマホゲーム「走れ！ターン王子」をプレイし、ゴールした際にアクセスできる各賞の応募画面から、自動で入力されたツイート文のまま投稿した方
            p.frame-textarea-text.text-indent ・日本国内にお住まいの方、かつ賞品のお届けが日本国内の方。
            .text-nest
              p.frame-textarea-text.text-indent ※亀田製菓社員および関係者は応募できません。

          h3.frame-textarea-title 利用規約
          .frame-textarea-inner.text-nest.text-break
            p.frame-textarea-text.text-indent ●応募が完了した時点で、本利用規約の全てにご同意いただいたものとみなします。
            p.frame-textarea-text.text-indent ●本利用規約に記載のない事項については、当社及び事務局が最終的な決定権を持つものとします。
            p.frame-textarea-text.text-indent ●本キャンペーンのご当選者は、同時期に実施されている当社の他の消費者キャンペーンとは重複してご当選できない場合がございます。
            p.frame-textarea-text.text-indent ●ご応募は日本国内にお住まいの方で、かつ賞品のお届けが日本国内の方に限らせていただきます。
            p.frame-textarea-text.text-indent ●応募者様本人の都合により当選の連絡ができない場合は当選を無効とさせていただきます。
            p.frame-textarea-text.text-indent ●応募後にハッピーターン公式Twitterアカウントのフォローを外されている場合、ユーザーIDを変更された場合、アカウント名が変更された場合、Twitterを退会されていた場合は抽選対象外となり、当選されていた場合も無効となりますのでご注意ください。
            p.frame-textarea-text.text-indent ●当社社員及びそのご家族、関係者の応募はできません。
            p.frame-textarea-text.text-indent ●当選権利の他人への譲渡や換金、他の賞品との引き換えはできません。
            p.frame-textarea-text.text-indent ●ご当選者の住所、転居先が不明または長期不在などの理由により賞品がお届けできない際には、当選を取り消しさせていただく場合がございます。
            p.frame-textarea-text.text-indent ●賞品は、予期せぬ事由などにより、予告なく変更する場合がございます。
            p.frame-textarea-text.text-indent ●ご応募後の、受付確認、当選の有無などのお問い合わせにはお答えできません。
            p.frame-textarea-text.text-indent ●ご応募いただいた投稿や画像の削除、変更及び応募の取消はキャンペーン事務局ではお受けできません。
            p.frame-textarea-text.text-indent.text-break ●ご投稿いただいた画像を亀田製菓のサイトやSNSアカウント、もしくは雑誌などのメディアに掲載する場合がございます。なおご応募いいただいた画像に関する著作権（著作権法第27条、第28条の権利を含みます）その他の知的財産権は当社に帰属するものとします。また掲載時には個別にお知らせすることはございませんので、予めご了承のうえ、ご応募ください。

            p.frame-textarea-text.text-indent ●本キャンペーンはTwitter社とは一切関係ありません。
            p.frame-textarea-text.text-indent ●当社及び事務局は、予告なく本キャンペーンの内容を変更することができるものとします。
            p.frame-textarea-text.text-indent ●当社及び事務局は、ネットワークの不具合、コンピューターウイルスの影響及びサーバーへの不正アクセスなど、当社及び事務局の支配の及ばない理由により、本キャンペーンの円滑な運営、安全性、公正性等が損なわれると判断したときは、予告なく本キャンペーンを終了もしくはルールを変更することができるものとし、それに関連して生じた参加者の損害等について、一切責任を負いません。
            p.frame-textarea-text.text-indent ●本キャンペーンへの応募に関連して参加者又は第三者が何らかの損害を被った場合であっても、当社及び事務局は、一切責任を負いません。利用者が本キャンペーンに関連するあらゆるWebサイトを利用する場合、当社及び事務局は、本キャンペーンに関連するあらゆるWebサイトに掲載される情報の正確性、合法性、道徳性、最新性、適切性などについて保証することはできません。
            p.frame-textarea-text.text-indent ●本キャンペーンの応募にあたり、以下の行為のいずれかに該当、又は当社若しくは事務局が該当すると判断する行為をした場合は、当社若しくは事務局の判断で応募を無効とする、又は損害賠償を請求することがございます。

            .text-nest
              p.frame-textarea-text.text-indent ○法令に違反する行為
              p.frame-textarea-text.text-indent ○犯罪に関連する行為・公序良俗に反する行為
              p.frame-textarea-text.text-indent ○賞品をキャンペーンの目的とは異なる方法（転売、非難目的を含みます）で使用する行為

            p.frame-textarea-text.text-indent ●当社及び事務局は、本キャンペーンに関連するあらゆるWebサイトを利用したこと、又は利用ができないこと、本キャンペーンに関連するあらゆるWebサイトからのリンク先を利用したこと、又は利用ができないことによって引き起こされた損害について、直接的又は間接的な損害を問わず一切責任を負わないものとします。
            p.frame-textarea-text.text-indent ●ご応募に発生するTwitterアプリ・キャンペーンサイトへの接続料や通信料はお客様ご自身の負担となります。
            p.frame-textarea-text.text-indent ●キャンペーンに関するお問い合わせは、「走れ！ターン王子」キャンペーン事務局までお願いいたします。
            p.frame-textarea-text.text-indent ●本キャンペーンについてのお問い合わせはAmazonではお受けしておりません。
            p.frame-textarea-text.text-indent ●Amazon、Amazon.co.jpおよびそれらのロゴはAmazon.com, Inc.またはその関連会社の商標です。

          h3.frame-textarea-title 個人情報の取り扱いについて
          .frame-textarea-inner.text-nest
            p.frame-textarea-text.text-indent ※ご記入いただいた個人情報は、当選者の連絡及び賞品の発送と個人を特定しない統計情報として使用させていただき、お客様の同意なしに業務委託先以外の第三者に開示、提供することは一切ございません。(法令等により開示を求められた場合を除く)なお、いただいた個人情報は当社グループの個人情報保護方針に基づき安全かつ適切に管理いたします。詳しくは当社ホームページにて、『#[a(href="https://www.kamedaseika.co.jp/cs/?p=policy.policyIndex" target="_blank" rel="noopener") プライバシーポリシー]』をご確認ください。
</template>

<script>
import CloseButton from '@/components/CloseButton';

export default {
  name: 'Terms',
  components: {
    CloseButton
  }
};
</script>

<style scoped lang="scss">
.page-terms {
  padding: vw(85) 0;
  background: image-url('common/bg_castle.png') no-repeat
    map-get($primary_color, 'grass');
  background-size: 100% auto;
  .frame {
    width: vw(1218);
    height: vw(1762);
    margin: 0 auto;
    background: image-url('common/image_frame.png') no-repeat;
    background-size: 100% auto;
  }
}
</style>
